import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

export const getAllSubjectsPortal = async () => {
  const res = await axiosInstance.get("/subject-portal/all");
  return res.data;
};

export const getSubjectByIdPortal = async (id) => {
  const res = await axiosInstance.get(`/subject-portal/${id}`);
  return res.data;
};